import { PRODUCT_CATEGORY, PRODUCT_TYPES } from '@schuettflix/interfaces';
import { productTypeToProductCategoryMap } from './constants/productTypeToProductCategoryMap.ts';

export function getProductTypesByProductCategory(productCategory: PRODUCT_CATEGORY): PRODUCT_TYPES[] {
    return Object.entries(productTypeToProductCategoryMap)
        .filter(([_, category]) => category === productCategory)
        .map(([productType]) => productType as PRODUCT_TYPES);
}
